import { Card, Flex, Heading, Highlight, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';
import { integrationsList } from '../lib/integrationsList';

const HEADING_TEXT = `Streamline Your Workflow:\nIntegrations with Leading Platforms`;
const SUB_HEADING_TEXT =
  'Explore how LocalProf leverages integrations to enhance your online presence and attract more clients';

const Integrations = () => {
  const router = useRouter();

  return (
    <>
      <MetaDecorator
        description='meta.integrations.main.description'
        title='meta.integrations.main.title'
      />
      <DefaultContainer
        alignItems='center'
        gap='xl'
      >
        <Heading
          as='h1'
          textAlign='center'
          whiteSpace='pre-wrap'
        >
          <Highlight
            query={['Leading Platforms']}
            styles={{ color: 'primary.pure' }}
          >
            {HEADING_TEXT}
          </Highlight>
        </Heading>
        <Text fontSize='lg'>
          <Highlight
            query={['LocalProf']}
            styles={{ color: 'primary.pure' }}
          >
            {SUB_HEADING_TEXT}
          </Highlight>
        </Text>
        <Flex
          flexWrap='wrap'
          gap='lg'
        >
          {integrationsList.map(({ heading, Icon, text, url }) => (
            <Card
              key={heading}
              cursor='pointer'
              gap='md'
              maxW='25rem'
              p='lg'
              variant='solid'
              onClick={() => router.push(url)}
            >
              <Flex
                alignItems='center'
                gap='lg'
                justifyContent='space-between'
              >
                <Heading fontSize='lg'>{heading}</Heading>
                <Icon w='20' />
              </Flex>
              <Text>{text}</Text>
            </Card>
          ))}
        </Flex>
      </DefaultContainer>
    </>
  );
};

export default Integrations;
